// extracted by mini-css-extract-plugin
export default {"seoBlockContent":"c-a_fw","seoBlockContent_visible":"c-a_fx"};